import React, { useState, useContext, useEffect } from "react";
import { AuthContext } from "../../../context/auth";
import axios from "axios";
import { ImpSectorEjidos } from "./modalImprimirEjidos";
import TablaContribuyenteEjidos from "./tablaContribuyentesEjidos";
import { TablaTiposRentas } from "./tablaTipoRentas";
import { TablaClasificadorAseo } from "./tablaClasificador";
import { TablaEstadoCuenta } from "./tablaEstadoEjido";
import TablaAseoUrbano from "./tablaAseoUrbano";
import Grafica from "./graficas";
import { ModalConfiguracionRentas } from "./modalConfigRentas";
import TablaUsuarioRenta from "./tablaUsuarioRenta";
import TablaContribuyenteEconomiaInformal from "./tablaContribuyentesEconomiaInformal";
import TablaContribuyenteResiduosSolidos from "./tablaContribuyentesResiduosSolidos";
import { TablaClasificadorRS } from "./tablaClasificadorRS";

import Menu from "../../comun/Menu/Menu";
import Item from "../../comun/Menu/Item";

function MenuPrincipalEjido() {
  const { user } = useContext(AuthContext);

  const [rentas, setRentas] = useState();
  const [fechaSistema, setFechaSistema] = useState(
    localStorage.getItem("fechasistema"),
  );

  const [configRenta, setConfigRenta] = useState(0.0);

  let token = localStorage.getItem("jwtToken");
  let op = require("../../../../src/modulos/datos");
  const espiritu = JSON.parse(localStorage.getItem("espiritu"));

  const seleccionarRegistros = () => {
    let campos = "*";
    let nomtab = "tiporentas";
    let orden = "idtiporentas";

    let endpoint =
      op.conexion +
      `/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setRentas(response.data);
        }
      })
      .catch(function () {});
  };

  const configRentas = () => {
    let endpoint = `${op.conexion}/api/aseo/configrentas`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data !== "") {
            setConfigRenta(response.data);
          }
        }
      })
      .catch(() => {});
  };

  const seleccionarRegistrostipo = () => {
    let campos = "*";
    let nomtab = "clasevehiculo";
    let orden = "idclasevehiculo";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          let desc = 0;
          for (var i = 0; i < response.data.length; i++) {
            desc = desc + 1;
          }
        }
      })
      .catch(function () {});
  };

  useEffect(() => {
    let obj = JSON.parse(localStorage.getItem("post"));
    setFechaSistema(obj.fechasistema);
    if (obj != null) {
    } else {
    }
    seleccionarRegistros();
    //seleccionarRegistros();
    seleccionarRegistrostipo();
    configRentas();
  }, []);

  const actualizacionItem = {
    title: "Actualizacion",
    icon: "fa fa-pen me-2",
    drop: [
      {
        title: "Registro de ejidos o rentas municipales",
        icon: "fa fa-user-plus me-2",
        itemClickValue: 1,
      },
      {
        title: " Registro de aseo municipal",
        icon: "fa fa-pen-square me-2",
        itemClickValue: 2,
      },
      {
        title: " Estado de Cuenta Rentas inmobiliarias",
        icon: "fa fa-file-powerpoint me-2",
        itemClickValue: 5,
      },
      {
        title: "Registro de economia informal",
        icon: "fa fa-user-plus me-2",
        itemClickValue: 12,
      },
      espiritu === 0
        ? {
            title: "Registro de disposición residuos sólidos",
            icon: "fa fa-user-plus me-2",
            itemClickValue: 13,
          }
        : "",
      {
        title: "Tipo de renta municipal",
        icon: "fas fa-address-card me-2",
        itemClickValue: 3,
      },
      {
        title: "Clasificador de aseo comercial/industrial",
        icon: "fa fa-pen-square me-2",
        itemClickValue: 4,
      },
      espiritu === 0
        ? {
            title: "Clasificador de disposición de residuos sólidos",
            icon: "fa fa-pen-square me-2",
            itemClickValue: 14,
          }
        : "",
    ],
  };

  const imprimirItem = {
    title: "Imprimir",
    icon: "fa fa-print me-2",
    drop: [
      {
        title: "Contribuyentes rentas inmobiliarias",
        icon: "fa fa-file-powerpoint me-2",
        itemClickValue: 6,
      },

      {
        title: "Contribuyentes con contratos vencidos",
        icon: "fa fa-file-powerpoint me-2",
        itemClickValue: 7,
      },
      {
        title: "Contribuyentes con deudas",
        icon: "fa fa-file-powerpoint me-2",
        itemClickValue: 8,
      },
      {
        title: "Listado tipo de deuda",
        icon: "fa fa-file-powerpoint me-2",
        itemClickValue: 9,
      },
    ],
  };
  const configuracionItem = {
    title: "Configuracion",
    icon: "fa fa-cog me-2",
    drop: [
      {
        title: "Configuracion del modulo",
        icon: "fa fa-screwdriver me-2",
        itemClickValue: 10,
      },
      {
        title: "Usuarios",
        icon: "fa fa-user me-2",
        itemClickValue: 11,
      },
    ],
  };

  const [show, setShow] = useState(false);
  const [tabla, setTabla] = useState(0);

  useEffect(() => {
    if (tabla === 9) {
      const reporte = "ListTipoRentas";
      window.open(op.reportes + "/rentasinmobiliarias?" + "reporte=" + reporte);
    }
  }, [tabla]);

  const PorDefecto = () => {
    const azulProfundo = "#003a70";
    const azulVibrante = "#007bff";

    return (
      <section
        className="col-12 m-0 p-0"
        style={{ height: "90dvh", overflow: "hidden" }}
      >
        <style>{`
          @keyframes float {
            0% { transform: translateY(0px) translateX(0px); opacity: 0.6; }
            50% { transform: translateY(-20px) translateX(10px); opacity: 1; }
            100% { transform: translateY(0px) translateX(0px); opacity: 0.6; }
          }
          .tech-dot {
            position: absolute;
            background: white;
            border-radius: 50%;
            animation: float 6s infinite ease-in-out;
          }
        `}</style>

        <div
          className="col-md-12 row mx-auto px-0"
          style={{ minHeight: "100%" }}
        >
          <div
            className="col-md-6 d-flex justify-content-center align-items-center"
            style={{
              position: "relative",
              left: "-50px",
              borderBottomRightRadius: "30%",
              height: "90dvh",
              backgroundColor: azulProfundo,
              overflow: "hidden",
              boxShadow: "10px 0 30px rgba(0,0,0,0.2)",
            }}
          >
            {/* 1. FONDO MESH GRADIENT (Profundidad) */}
            <div
              style={{
                position: "absolute",
                inset: 0,
                background: `
                radial-gradient(circle at 20% 30%, ${azulVibrante} 0%, transparent 50%),
                radial-gradient(circle at 80% 70%, #00d4ff 0%, transparent 50%),
                ${azulProfundo}
              `,
              }}
            />

            {/* 2. REJILLA TECNOLÓGICA (Grid lines) */}
            <div
              style={{
                position: "absolute",
                inset: 0,
                backgroundImage: `linear-gradient(rgba(255,255,255,0.05) 1px, transparent 1px), 
                                linear-gradient(90deg, rgba(255,255,255,0.05) 1px, transparent 1px)`,
                backgroundSize: "50px 50px",
              }}
            />

            {/* 3. PUNTOS ANIMADOS (Partículas) */}
            <div
              className="tech-dot"
              style={{
                width: "6px",
                height: "6px",
                top: "20%",
                left: "15%",
                animationDelay: "0s",
              }}
            />
            <div
              className="tech-dot"
              style={{
                width: "4px",
                height: "4px",
                top: "60%",
                left: "25%",
                animationDelay: "1s",
              }}
            />
            <div
              className="tech-dot"
              style={{
                width: "8px",
                height: "8px",
                top: "40%",
                left: "80%",
                animationDelay: "2s",
              }}
            />
            <div
              className="tech-dot"
              style={{
                width: "3px",
                height: "3px",
                top: "80%",
                left: "60%",
                animationDelay: "1.5s",
              }}
            />

            {/* 4. RÁFAGAS DE LUZ DIAGONALES */}
            <div
              style={{
                position: "absolute",
                inset: 0,
                background:
                  "linear-gradient(135deg, rgba(255,255,255,0.1) 0%, transparent 20%, rgba(255,255,255,0.05) 50%, transparent 100%)",
                transform: "skewX(-20deg)",
              }}
            />

            {/* LOGO CON GLOW */}
            <div
              style={{ position: "relative", zIndex: 10, textAlign: "center" }}
            >
              {/* <img
                style={{
                  filter: "drop-shadow(0px 0px 30px rgba(255,255,255,0.3))",
                  maxWidth: "100%",
                  transition: "transform 0.3s ease",
                }}
                className="img-fluid"
                src={op.imagenes + "/imagen?img=" + op.logohacienda}
                alt="Logo SIAP"
              /> */}
              <h3
                style={{
                  position: "relative", // Cambiado de absolute a relative para trabajar con flexbox
                  fontSize: "40px",
                  color: "#ffffff",
                  textAlign: "center", // Asegura que el texto esté centrado
                  width: "100%", // Ocupa todo el ancho disponible
                }}
              >
                RENTAS INMOBILIARIAS
              </h3>
            </div>
          </div>

          {/* LADO DERECHO (Alcaldía) */}
          <div className="col-md-6 d-flex justify-content-center align-items-center">
            <img
              className="img-fluid px-5"
              src={op.imagenes + "/imagen?img=" + op.logohacienda}
              alt="Logo Alcaldía"
              style={{ maxWidth: "85%" }}
            />
          </div>
        </div>
      </section>
    );
  };
  const vista = {
    0:<TablaContribuyenteEjidos/>,
    1: <TablaContribuyenteEjidos setTabla={setTabla} />,
    2: <TablaAseoUrbano setTabla={setTabla} />,
    3: <TablaTiposRentas setTabla={setTabla} />,
    4: <TablaClasificadorAseo setTabla={setTabla} />,
    5: <TablaEstadoCuenta setTabla={setTabla} />,
    6: (
      <ImpSectorEjidos
        show={show}
        setShow={setShow}
        rentas={rentas}
        tabla={tabla}
      />
    ),
    7: (
      <ImpSectorEjidos
        show={show}
        setShow={setShow}
        rentas={rentas}
        tabla={tabla}
      />
    ),
    8: (
      <ImpSectorEjidos
        show={show}
        setShow={setShow}
        rentas={rentas}
        tabla={tabla}
      />
    ),

    10: (
      <ModalConfiguracionRentas
        show={show}
        config={configRenta}
        setShow={setShow}
        render={configRentas}
      />
    ),
    11: <TablaUsuarioRenta setTabla={setTabla} />,
    12: <TablaContribuyenteEconomiaInformal setTabla={setTabla} />,
    13: <TablaContribuyenteResiduosSolidos setTabla={setTabla} />,
    14: <TablaClasificadorRS setTabla={setTabla} />,
  };

  return (
    user && (
      <div className="w-100 col-12 m-0 p-0">
        <Menu fechaSistema={fechaSistema} op={op} show={() => setTabla(0)}>
          <Item
            item={actualizacionItem}
            setTabla={setTabla}
            setShow={setShow}
          />
          <Item item={imprimirItem} setTabla={setTabla} setShow={setShow} />
          <Item
            item={configuracionItem}
            setTabla={setTabla}
            setShow={setShow}
          />
          <a
            href="/haciendaMunicipal"
            className="list-group-item list-group-item-action bg-transparent text-danger fw-bold"
          >
            <i className="fas fa-power-off me-2" />
            Salir
          </a>
        </Menu>
        <section
          className="w-100 col-12 m-0 p-0 d-flex align-items-center justify-content-center"
          style={{ height: "100dvh" }}
        >
          {vista[tabla]}
        </section>
      </div>
    )
  );
}
export default MenuPrincipalEjido;
